import React, { useContext } from 'react';
import classes from './change-kilometer-form.module.scss';
import { EditForm } from 'components/form-hook/components/edit-form/edit-form';
import { useForm } from 'react-hook-form';
import { ChangeKilometerFormFieldValues, ChangeKilometerFormProps } from './change-kilometer-form.props';
import { getChangeKilometerForm } from './form-field';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { fleetRequestConfig } from 'request-config/fleet/fleet.request-config';
import { VehicleDetailContext } from 'pages/existing-vehicle-page/existing-vehicle.context';
import moment from 'moment';

export const ChangeKilometerForm = ({ onClose, layout, ...flexProps }: ChangeKilometerFormProps) => {
  const { vehicle, setRefreshKey } = useContext(VehicleDetailContext);
  const reactHookFormData = useForm<ChangeKilometerFormFieldValues>();

  const { fetch } = useFetch({
    loadingKey: 'changeKilometer',
    isShowSuccessSnackbar: true,
    successMessage: 'KM-Stand wurde erfolgreich gespeichert'
  });
  const formFields = getChangeKilometerForm(layout === 'row');

  const submitHandler = (values: ChangeKilometerFormFieldValues) => {
    const carId = vehicle.fuhrpark?.new_fuhrparkid?.attributeValue;

    if (carId) {
      fetch({
        requestConfig: fleetRequestConfig.setKilometers({
          uds_markid: carId,
          uds_mileage: Number(values.uds_mileage),
          uds_date_of_mileage: moment(values.uds_date_of_mileage).format('YYYY-MM-DD')
        }),
        callback: () => {
          onClose && onClose();
          setRefreshKey(prevState => ++prevState);
        }
      });
    }
  };

  if (layout === 'row') {
    return (
      <EditForm<ChangeKilometerFormFieldValues>
        className={classes.row_edit_form_container}
        idPrefix='kilometerForm'
        containerFlex={{ width: '100%', ...flexProps }}
        distanceBetweenFields='0'
        label=''
        reactHookFormData={reactHookFormData}
        formFields={formFields}
        onSubmit={submitHandler}
        onClose={onClose}
      />
    );
  }

  return (
    <EditForm<ChangeKilometerFormFieldValues>
      idPrefix='kilometerForm'
      containerFlex={{ width: '100%', ...flexProps }}
      distanceBetweenFields='20'
      label='Km-Stand'
      reactHookFormData={reactHookFormData}
      formFields={formFields}
      onSubmit={submitHandler}
      onClose={onClose}
    />
  );
};
